/**
 * i18n Configuration - Internationalisation FR/EN/DE/ES
 * Y GO Shuttle Services France
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import fr from './locales/fr.json';
import en from './locales/en.json';
import de from './locales/de.json';
import es from './locales/es.json';

const resources = {
  fr: { translation: fr },
  en: { translation: en },
  de: { translation: de },
  es: { translation: es }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'fr',
    supportedLngs: ['fr', 'en', 'de', 'es'],
    
    detection: {
      // Order of detection
      order: ['localStorage', 'navigator', 'htmlTag'],
      // Cache language in localStorage
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng'
    },
    
    interpolation: {
      escapeValue: false // React already escapes
    },
    
    react: {
      useSuspense: false
    }
  });

export default i18n;

// Helper to sync user language with i18n
export const syncUserLanguage = (userLanguage) => {
  if (userLanguage && ['fr', 'en', 'de', 'es'].includes(userLanguage)) {
    i18n.changeLanguage(userLanguage);
    localStorage.setItem('i18nextLng', userLanguage);
  }
};

// Get current language
export const getCurrentLanguage = () => {
  return i18n.language || 'fr';
};

// Change language
export const changeLanguage = (lang) => {
  if (['fr', 'en', 'de', 'es'].includes(lang)) {
    i18n.changeLanguage(lang);
    localStorage.setItem('i18nextLng', lang);
    return true;
  }
  return false;
};
